import { Trip, Content } from './../classes.js';

export function text__element(data, edit = false){
	let $content = '';
	let $as_label = '';
	let $as_input = '';
	
	//create the trip title element // edit or read
	if(edit){
		$content = $('<div/>', {
			'class': 'e editable form__row',
			'data-el_id': data.id,
			'data-block_id': data.block_id
		});
		
		$as_label = $('<span/>', {
			'class': 'fake_label',
			'text': 'Text Content'
		});
		
		$as_input = $('<div/>', {
			'id': `b[${data.block_id}][e][${data.id}][c][text]`,
			'class': 'tbw-editor',
		});
		$as_input.append(data.c.text);
		
		$content.append($as_label, $as_input);
	}else{
	
		$content = $('<div/>', {
			'class': 'e editor',
			'data-el_id': data.id,
			'data-block_id': data.block_id
		});
		$content.append(data.c.text);
		
		if(Trip.has_permission){
			$as_input = $('<input/>', {
				'type': 'hidden',
				'name': `b[${data.block_id}][e][${data.id}][c][text]`,
				'value': data.c.text
			});
			$content.append($as_input);
		}
	}
	if(Trip.has_permission || Content.edit){
		
		$content.append(`<input class="element_order" type="hidden" name="b[${data.block_id}][e][${data.id}][order]" value="${data.order}" />`);
		$content.append(`<input class="element_priority" type="hidden" name="b[${data.block_id}][e][${data.id}][priority]" value="${data.priority}" />`);
		$content.append(`<input type="hidden" name="b[${data.block_id}][e][${data.id}][type]" value="text" />`);
	}
	return $content;
}

